import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import StreamCanvas from '../components/StreamCanvas';
import ScanConsole from '../components/ScanConsole';
import { GrowthLoopSection } from './sections';
import ServiceGrid from './ServiceGrid';

export default function Home() {
  return (
    <>
      <section className="hero hero-home">
        <StreamCanvas />
        <div className="hero-content">
          <div className="hero-badge">LOCAL VISIBILITY + CUSTOMER CONVERSION OS</div>
          <h1 className="hero-title">
            Get Ranked.<br />
            <span className="gradient-text">Without lifting a finger.</span>
          </h1>
          <p className="hero-sub">
            Conversion-ready websites, Google Business Profile tracking, and AI-assisted local SEO —
            at a fair, transparent price.<br />
            One platform, one invoice, results you can measure.
          </p>

          <ScanConsole />

          <div className="hero-stats">
            <div className="stat">
              <span className="stat-num">41</span>
              <span className="stat-lbl">Workflow Modules</span>
            </div>
            <div className="stat-div" />
            <div className="stat">
              <span className="stat-num">15</span>
              <span className="stat-lbl">AI Builders</span>
            </div>
            <div className="stat-div" />
            <div className="stat">
              <span className="stat-num">4</span>
              <span className="stat-lbl">Growth Plans</span>
            </div>
          </div>
        </div>
      </section>

      <GrowthLoopSection />

      <ServiceGrid />

      <section className="home-cta">
        <div className="home-cta-inner">
          <div>
            <div className="section-tag">START WHERE IT HURTS MOST</div>
            <h2>See the full platform, or just fix one thing.</h2>
            <p>Explore every tool by plan, compare pricing, or run the free visibility scan first. No account required to start.</p>
          </div>
          <div className="home-cta-actions">
            <Link to="/products" className="btn-primary">Explore the platform <ArrowRight size={16} /></Link>
            <Link to="/pricing" className="btn-ghost">Compare plans</Link>
          </div>
        </div>
      </section>
    </>
  );
}
